type Props = {
  days: number
}

const FreeWindowNotice = ({ days }: Props) => (
  <div className="free-window-notice">
    <i className="bi bi-info-circle" />
    <span>直近{days}日までのデータを表示しています（プロプランで全期間を表示できます）</span>
  </div>
)

export default FreeWindowNotice
